






















import { Component, Vue } from 'vue-property-decorator';
import FlexButton from '@/components/FlexButton/FlexButton.vue';
import eventBus from '@/utils/eventBus';
@Component({
  components: {
    FlexButton
  }
})
export default class ForgotPassowrd extends Vue {
  counter: number = 0;
  busy: boolean = false;
  interval: any = {};

  mounted() {
    this.resendEmail();
  }

  decrement() {
    this.interval = setInterval(() => {
      if (this.counter === 0) {
        this.busy = false;
        return;
      }
      this.counter--;
    }, 1000);
  }

  emitResend() {
    clearInterval(this.interval);
    this.resendEmail();
    eventBus.$emit('resendEmail');
  }

  get getMinutes() {
    const { counter: seconds } = this;
    let minutesRemain = Math.floor(seconds / 60).toString();
    let secondsReman = (seconds % 60).toString();
    minutesRemain = minutesRemain.padStart(2, '0');
    secondsReman = secondsReman.padStart(2, '0');
    return `${minutesRemain}:${secondsReman}`;
  }

  resendEmail() {
    if (this.busy) return;
    this.busy = true;
    this.counter = 120;
    this.decrement();
  }

  goToLogin() {
    this.$router.push('/');
    this.closeModal();
  }

  closeModal() {
    eventBus.$emit('closeModal');
  }
}
